import { twMerge } from 'tailwind-merge';

import { useDataContext } from '@/_provider';

export function Container({ className, children }) {
  const { currentObj } = useDataContext();
  return <div className={twMerge(`flex-1 ${currentObj.backgroundColor}`, className)}>{children}</div>;
}
